import type { RootState } from '../configure-store';

export const selectRandomNumber = (state: RootState) =>
    state.random.randomNumber;
